<template>
  <div
    :class="[
      'page-error',
      { 'is-centered': isCentered }
    ]"
  >
    <el-icon
      v-if="icon"
      class="error-icon"
      :name="icon"
    />
    <div
      v-else-if="image"
      class="error-image"
    >
      <img
        :src="image"
        :alt="title || $t('Something went wrong')"
      />
    </div>
    <div
      v-else
      class="code"
    >
      {{ code }}
    </div>
    <div class="title">
      {{ title || $t('Something went wrong') }}
    </div>
    <div class="message">
      {{ message || $t('We are working to resolve it.') }}
    </div>
    <form :action="!buttonAction && buttonRedirect">
      <el-button
        class="goto-button"
        native-type="submit"
        @click="buttonClick"
      >
        {{ buttonText || $t('Go to main page') }}
      </el-button>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'PageError',
    props: {
      code: {
        type: Number,
        default: () => null
      },
      icon: String,
      image: String,
      title: String,
      message: String,
      isCentered: Boolean,
      buttonText: String,
      buttonRedirect: {
        type: String,
        default() {
          return '/';
        }
      },
      buttonAction: {
        type: Function,
      }
    },
    methods: {
      buttonClick(e) {
        if (typeof this.buttonAction === 'function') {
          e.preventDefault();
          this.buttonAction();
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  $error-icon-size: 360px;
  $error-code-size: 356px;

  .page-error {
    font-family: $av-font-family;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: $av-nav-primary;

    .error-icon {
      position: fixed;
      opacity: 0.03;
      color: $av-inversed-primary;

      &::before {
        width: $error-icon-size;
        height: $error-icon-size;
        font-size: $error-icon-size;
      }
    }

    .error-image {
      position: fixed;
      opacity: 0.03;

      img {
        width: $error-icon-size;
        height: $error-icon-size;
      }
    }

    .code {
      position: fixed;
      font-size: $error-code-size;
      opacity: 0.03;
      color: $av-inversed-primary;
    }

    .title {
      font-size: $av-font-size-m;
      font-weight: $av-font-weight-bold;
      line-height: $av-line-height-m;
      color: $av-inversed-primary;
    }

    .message {
      font-size: $av-font-size-xs;
      line-height: $av-line-height-s;
      color: $av-inversed-primary;
    }

    &.is-centered {
      .message,
      .title {
        max-width: 320px;
        text-align: center;
      }
    }

    .goto-button {
      margin-top: 24px;
    }
  }
</style>
